var _rect, _rect2, _rect3, _rect4;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHapDesign(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 899,
    viewBox: "0 0 480 899",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 228,
    height: 420,
    rx: 114,
    fill: "#F77611"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 440,
    width: 228,
    height: 360,
    rx: 114,
    fill: "#FFCC33"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 169,
    width: 228,
    height: 360,
    rx: 114,
    fill: "#38DED6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 549,
    width: 228,
    height: 350,
    rx: 114,
    fill: "#04C362"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHapDesign);
export default __webpack_public_path__ + "static/media/hap-design.0a4c0594f542fdec068a562579c433f0.svg";
export { ForwardRef as ReactComponent };